export function getAssetUrl(
  rawUrl: string | null | undefined,
  config: {
    restaurant_id?: string | null;
    imagesVersion?: string | null;
    placeholder_url?: string | null;  // ← agregar esto
  },
  type: "image" = "image"  // ← default value, ya no es requerido
): string {
  const supa = import.meta.env.VITE_SUPABASE_URL;
  let url = rawUrl?.trim() || "";

  // 👉 Si no hay imagen → vacío
  if (!url || url === "/") {
    return "";
  }

  // 👉 Si NO es URL completa → armar URL de Supabase
  if (!url.startsWith("http")) {
    const bucket = type === "image" ? "product-images" : "menu-data";
    url = `${supa}/storage/v1/object/public/${bucket}/${config.restaurant_id}/${url}`;
  }

  // 👉 cache busting
  const v = config.imagesVersion || "1";
  const join = url.includes("?") ? "&" : "?";

  return `${url}${join}v=${v}`;
}